import axios from 'axios'

export default class toolApi {
  static getList({ page, size }) {
    return axios.get('/high/tool/getList', { params: { page, size } })
  }

  static getDetail(id) {
    return axios.get('/high/tool/detail/' + id)
  }

  static getRecommendList(id, size) {
    return axios.get('/high/tool/getRandList?id=' + id + "&size=" + size)
  }
}



// WEBPACK FOOTER //
// ./src/api/toolApi.js